// Organization industry enum (values match backend INDUSTRIES) + German labels.
export const INDUSTRIES = [
  { value: "CONSTRUCTION", label: "Bau" },
  { value: "CARE", label: "Pflege / Ambulanter Pflegedienst" },
  { value: "LOGISTICS", label: "Logistik" },
  { value: "GASTRONOMY", label: "Gastronomie" },
  { value: "CLEANING", label: "Reinigung" },
  { value: "INDUSTRY", label: "Industrie" },
  { value: "SECURITY", label: "Sicherheitsdienst" },
  { value: "OTHER", label: "Sonstige" },
];

export const INDUSTRY_LABEL = Object.fromEntries(INDUSTRIES.map((i) => [i.value, i.label]));
